import script from "./CalendarMonth.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarMonth.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarMonth.vue?vue&type=style&index=0&id=615ed222&lang=css"

const __exports__ = script;

export default __exports__